export default {"src":"/_next/static/media/dave_sig.24b76f1e.svg","height":33,"width":223,"blurWidth":0,"blurHeight":0};